// AUTO-GENERATED by scripts/process-sessions.mjs — do not edit by hand.
// Edit scripts/sessions.config.json for titles/venues/dates/categories, then re-run
// `npm run process:sessions`.

export const SESSIONS = [
  {
    "slug": "images-of-session-held-at-navneet-education-limited-export-through-huksa",
    "title": "Session at Navneet Education Ltd.",
    "venue": "Navneet Education Ltd. · In collaboration with HUKSA",
    "date": "",
    "category": "self-improvement",
    "categoryLabel": "Self Improvement",
    "order": 1,
    "cover": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-01.webp",
    "photos": [
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-01.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-01.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-02.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-02.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-03.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-03.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-04.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-04.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-05.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-05.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-06.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-06.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-07.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-07.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-08.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-08.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-09.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-09.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-10.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-10.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-11.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-11.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-12.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-12.webp",
        "w": 1600,
        "h": 1058
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-13.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-13.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-14.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-14.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-15.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-15.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-16.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-16.webp",
        "w": 1600,
        "h": 1200
      },
      {
        "full": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/full-17.webp",
        "thumb": "/assets/img/sessions/images-of-session-held-at-navneet-education-limited-export-through-huksa/thumb-17.webp",
        "w": 1600,
        "h": 1200
      }
    ]
  },
  {
    "slug": "goldenshot-sports",
    "title": "Goldenshot Sports",
    "venue": "Session on Communication, Confidence and Presence",
    "date": "",
    "category": "communication-skills",
    "categoryLabel": "Communication Skills",
    "order": 2,
    "cover": "/assets/img/sessions/goldenshot-sports/thumb-01.webp",
    "photos": [
      {
        "full": "/assets/img/sessions/goldenshot-sports/full-01.webp",
        "thumb": "/assets/img/sessions/goldenshot-sports/thumb-01.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/goldenshot-sports/full-02.webp",
        "thumb": "/assets/img/sessions/goldenshot-sports/thumb-02.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/goldenshot-sports/full-03.webp",
        "thumb": "/assets/img/sessions/goldenshot-sports/thumb-03.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/goldenshot-sports/full-04.webp",
        "thumb": "/assets/img/sessions/goldenshot-sports/thumb-04.webp",
        "w": 1200,
        "h": 1600
      },
      {
        "full": "/assets/img/sessions/goldenshot-sports/full-05.webp",
        "thumb": "/assets/img/sessions/goldenshot-sports/thumb-05.webp",
        "w": 960,
        "h": 1280
      }
    ]
  },
  {
    "slug": "ic-training-session-for-sang-fasteners-pvt-ltd",
    "title": "IC training session for Sang Fasteners Pvt. Ltd.",
    "venue": "Session on IC training session for Sang Fasteners Pvt. Ltd.",
    "date": "",
    "category": "ic-training",
    "categoryLabel": "IC Training",
    "order": 3,
    "cover": "/assets/img/sessions/ic-training-session-for-sang-fasteners-pvt-ltd/thumb-01.webp",
    "photos": [
      {
        "full": "/assets/img/sessions/ic-training-session-for-sang-fasteners-pvt-ltd/full-01.webp",
        "thumb": "/assets/img/sessions/ic-training-session-for-sang-fasteners-pvt-ltd/thumb-01.webp",
        "w": 1280,
        "h": 960
      },
      {
        "full": "/assets/img/sessions/ic-training-session-for-sang-fasteners-pvt-ltd/full-02.webp",
        "thumb": "/assets/img/sessions/ic-training-session-for-sang-fasteners-pvt-ltd/thumb-02.webp",
        "w": 1280,
        "h": 960
      },
      {
        "full": "/assets/img/sessions/ic-training-session-for-sang-fasteners-pvt-ltd/full-03.webp",
        "thumb": "/assets/img/sessions/ic-training-session-for-sang-fasteners-pvt-ltd/thumb-03.webp",
        "w": 1280,
        "h": 720
      }
    ]
  },
  {
    "slug": "posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant",
    "title": "POSH Awareness Session",
    "venue": "MCCIA, Pune · via Credence Consultant",
    "date": "",
    "category": "posh-awareness",
    "categoryLabel": "POSH Awareness",
    "order": 4,
    "cover": "/assets/img/sessions/posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant/thumb-01.webp",
    "photos": [
      {
        "full": "/assets/img/sessions/posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant/full-01.webp",
        "thumb": "/assets/img/sessions/posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant/thumb-01.webp",
        "w": 1280,
        "h": 960
      },
      {
        "full": "/assets/img/sessions/posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant/full-02.webp",
        "thumb": "/assets/img/sessions/posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant/thumb-02.webp",
        "w": 1280,
        "h": 960
      },
      {
        "full": "/assets/img/sessions/posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant/full-03.webp",
        "thumb": "/assets/img/sessions/posh-awareness-session-at-mahratta-chamber-of-commerce-industries-and-agriculture-pune-mccia-organised-by-credence-consultant/thumb-03.webp",
        "w": 1280,
        "h": 960
      }
    ]
  },
  {
    "slug": "posh-awareness-session-at-sang-fastener-thane",
    "title": "POSH Awareness Session",
    "venue": "Sang Fastener, Thane",
    "date": "",
    "category": "posh-awareness",
    "categoryLabel": "POSH Awareness",
    "order": 5,
    "cover": "/assets/img/sessions/posh-awareness-session-at-sang-fastener-thane/thumb-01.webp",
    "photos": [
      {
        "full": "/assets/img/sessions/posh-awareness-session-at-sang-fastener-thane/full-01.webp",
        "thumb": "/assets/img/sessions/posh-awareness-session-at-sang-fastener-thane/thumb-01.webp",
        "w": 1280,
        "h": 960
      },
      {
        "full": "/assets/img/sessions/posh-awareness-session-at-sang-fastener-thane/full-02.webp",
        "thumb": "/assets/img/sessions/posh-awareness-session-at-sang-fastener-thane/thumb-02.webp",
        "w": 1280,
        "h": 960
      }
    ]
  },
  {
    "slug": "child-posh-pocso",
    "title": "Future Ready Teens",
    "venue": "",
    "date": "",
    "category": "future-ready-teens",
    "categoryLabel": "Future Ready Teens",
    "order": 6,
    "cover": "/assets/img/sessions/child-posh-pocso/thumb-01.webp",
    "photos": [
      {
        "full": "/assets/img/sessions/child-posh-pocso/full-01.webp",
        "thumb": "/assets/img/sessions/child-posh-pocso/thumb-01.webp",
        "w": 960,
        "h": 1280
      },
      {
        "full": "/assets/img/sessions/child-posh-pocso/full-02.webp",
        "thumb": "/assets/img/sessions/child-posh-pocso/thumb-02.webp",
        "w": 1280,
        "h": 960
      },
      {
        "full": "/assets/img/sessions/child-posh-pocso/full-03.webp",
        "thumb": "/assets/img/sessions/child-posh-pocso/thumb-03.webp",
        "w": 960,
        "h": 1280
      },
      {
        "full": "/assets/img/sessions/child-posh-pocso/full-04.webp",
        "thumb": "/assets/img/sessions/child-posh-pocso/thumb-04.webp",
        "w": 960,
        "h": 1280
      }
    ]
  }
];
